"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedItemsHydratorReducer = void 0;

var redux_ts_simple_1 = require("redux-ts-simple");

var Immutable = require("seamless-immutable");

var ActivityFeedActions_1 = require("../../actions/ActivityFeedActions");

var INITIAL_STATE = Immutable({
  inProgress: false
});
exports.feedItemsHydratorReducer = new redux_ts_simple_1.ReducerBuilder(INITIAL_STATE).on(ActivityFeedActions_1.ActivityFeedActions.hydrateFeedItemsInProgress, function (state, action) {
  return state.merge({
    inProgress: action.payload
  });
}).on(ActivityFeedActions_1.ActivityFeedActions.hydrateFeedItemsCompleted, function (state, action) {
  return state.merge({
    feedItems: action.payload
  }, {
    deep: true
  });
}).on(ActivityFeedActions_1.ActivityFeedActions.resetFeedItems, function (state, action) {
  return state.setIn(["feedItems"], undefined);
}).build();